import React, { createContext, useState } from "react";
import en from "../assets/locales/en.json";
import de from "../assets/locales/de.json";

// Create the context
export const LanguageContext = createContext();

// Helper function to get nested translation key
const getNestedTranslation = (obj, key) => {
  return key.split('.').reduce((o, k) => (o && o[k] !== undefined ? o[k] : null), obj);
};

// Language provider component (wraps entire app)
export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState("DE");

  // Choose translations based on selected language
  const translations = language === "EN" ? en : de;

  // Translation function: returns the translated value or key
  const t = (key) => {
    const result = getNestedTranslation(translations, key);
    if (!result) {
      console.warn(`Missing translation for key: "${key}"`);
      return key;
    }
    return result;
  };

  // Provide context to children components
  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};
